// Footer.js
import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-gray-300 py-4">
      <div className="container mx-auto text-center">
        <p>© {new Date().getFullYear()} Tienda Kiwa. Todos los derechos reservados.</p>
        <div className="mt-2">
          <a href="https://facebook.com" className="mx-2 hover:text-white" target="_blank" rel="noopener noreferrer">
            Facebook
          </a>
          <a href="https://instagram.com" className="mx-2 hover:text-white" target="_blank" rel="noopener noreferrer">
            Instagram
          </a>
          <a href="https://twitter.com" className="mx-2 hover:text-white" target="_blank" rel="noopener noreferrer">
            Twitter
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
